import Bloc from './Bloc.js';
import Types from './Types.js';

export default class GainExp extends Bloc {

	constructor (src, ctx) {

		super("gainexp", src, ctx, true);
		this.f = (src, ins) => {
			if (src.corrupt && !src.fullCorruptActive)
				return [];
			if (ins[0] >= 0)
				src.master.run.champion.gainExp(ins[0]);
			else if (src.master.run.champion.availableExp > 0)
				src.master.stealExp(-ins[0]);
			return [];
		};
		this.types = [Types.int];
	}
}
